var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"remove-submit-modal"},[_c('remove-submit',{attrs:{"title":"Удалить метку?","subtitle":`Метка «${_vm.item.name}» будет удалена, а обращения, в которых она использовалась, останутся в системе`,"sending":_vm.sending},on:{"submit":_vm.remove,"cancel":function($event){return _vm.$rir.modal.close(null, true)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }